import {Store, Module, ActionContext} from 'vuex'
import PageResult from '@/store/entities/page-result';
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import Tpl from '../entities/tpls/tplForSelect'
import Customer from '../entities/customers/customer';
interface CustomerState extends ListState<Customer>{
}
class CustomerModule extends ListModule<CustomerState,any,Customer>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Customer>(),
        loading:false
    }
    actions={
        async getAll(context: ActionContext<CustomerState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/Customer/GetAll', { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<Customer>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async get(context:ActionContext<CustomerState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Customer/Get?Id='+payload.id);
            return reponse.data.result as Customer;
        },
        async getCustomerByKeyword(context:ActionContext<CustomerState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Customer/GetCustomerByCode/'+payload.data.keyWord);
            return reponse.data.result as Customer;
        },
        async searchCustomerForSelect(context:ActionContext<CustomerState,any>,payload:any){
            const {data:{result} }  =await Ajax.get('/api/services/app/Customer/SearchCustomerForSelect?keyWord='+payload.data.keyWord);
            return result.items  as Customer[];
        },
        async create(context: ActionContext<CustomerState, any>, payload: any) {
            await Ajax.post('/api/services/app/Customer/Create', payload.data);
        },
        async update(context: ActionContext<CustomerState, any>, payload: any) {
            await Ajax.put('/api/services/app/Customer/Update', payload.data);
        },
        async defaultTpl(context:ActionContext<CustomerState,any>,payload:any){
            const {data:{result} }  =await Ajax.get(`/api/services/app/Customer/${payload.data.id}/defaultTpl`);
            return result;
        },
    };
    mutations={
        setCurrentPage(state:CustomerState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:CustomerState,pagesize:number){
            state.pageSize=pagesize;
        }
    }
}
const customerModule=new CustomerModule();
export default customerModule;